/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-cont[_ngcontent-%COMP%]{height:7px;width:100%;border-radius:4px;background-color:#d0d0d0;position:relative}.progress-cont[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{width:0;height:100%;position:absolute;z-index:1;top:0;left:0;border-radius:4px;transition:.5s}\n/*# sourceMappingURL=progress.component.css.map*/"];
export { styles as styles };
